import React from 'react';
import './Landingpage.css';

const LandingPage = () => {
    return (
        <div className="black-background">
            <div className="centered-gradient"></div>

            <a
                href="https://dcm.tackoom.com"
                className="main-button"
            >
                Digital Counseling Marketplace →
            </a>

            <a
                href="https://tackoom.ai"
                className="floating-arrow"
            >
                ↓ Check Our Services
            </a>
        </div>
    );
}

export default LandingPage;
